export const getRankRange = (rating) => {
  switch (rating) {
    case 'Top 1 - 100':
      return { start: 1, end: 100 };
    case 'Top 1 - 200':
      return { start: 1, end: 200 };
    case 'Top 101 - 200':
      return { start: 101, end: 200 };
    case 'Top 201 - 500':
      return { start: 201, end: 500 };
    case 'Top 501 - 2000':
      return { start: 501, end: 2000 };
    case 'All Courses':
      return { start: 1, end: 2000 };
    default:
      return { start: 0, end: 0 };
  }
};
